let predicateActions = [];

/**
 * Middleware that will intercept any action with a "predicate" and store it for
 * later if its predicate doesn't match. Once the predicate matches, it will dispatch
 * the action and remove it from the predicate state
 *
 * The action that triggers this WILL BE RUN FIRST so the resulting state will be what
 * is passed to the predicate
 */
export default store => next => action => {
  if (action.predicate) {
    if (action.predicate(store.getState(), action)) {
      store.dispatch(action.action);
    } else {
      predicateActions.push(action);
    }
    return;
  }

  next(action);

  const actionsToDispatch = [];
  predicateActions = predicateActions.filter((predicate, i) => {
    if (predicate.predicate(store.getState(), action)) {
      actionsToDispatch.push(predicate.action);
      return predicate.persist;
    }
    return true;
  });

  actionsToDispatch.forEach(action => store.dispatch(action));
};
